import React, { useEffect, useRef } from "react";
import { useTaskStatus } from "../../../../../context/TaskStatusContext";
import IOSSpinner from "../../../../HtmlElements/IOSSpinner";

const PostSaveContainer = ({ taskId, postAction = () => {} }) => {
  const { getTaskData, getConnectionStatus } = useTaskStatus();
  const taskData = getTaskData(taskId);
  const isConnected = getConnectionStatus(taskId);
  const postActionFired = useRef(false);

  // Fire postAction once when completed and connection is closed (same logic you had)
  useEffect(() => {
    if (
      taskData?.status === "completed" &&
      isConnected === false &&
      !postActionFired.current
    ) {
      postActionFired.current = true;
      postAction();
    }
  }, [taskData?.status, isConnected, postAction]);

  // Common wrapper style
  const containerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    minWidth: "12rem",
  };

  if (taskData?.status === "failed") {
    return (
      <div style={containerStyle}>
        <span
          style={{
            background: "#fee2e2",
            color: "#991b1b",
            padding: "6px 10px",
            borderRadius: "8px",
            fontSize: "12px",
            fontWeight: 600,
          }}
        >
          Something went wrong
        </span>
      </div>
    );
  }

  if (taskData?.status === "completed") {
    return (
      <div style={containerStyle}>
        <span
          aria-label="Saved"
          style={{
            background: "blue",
            color: "#fff",
            padding: "8px 12px",
            borderRadius: "0.3rem",
            fontSize: "12px",
            fontWeight: 700,
            lineHeight: 1,
            boxShadow: "0 2px 10px rgba(91,34,255,0.25)",
          }}
        >
          Saved
        </span>
      </div>
    );
  }

  // Default & pending state → spinner only
  return (
    <div style={containerStyle}>
      <div style={{ width: "24px", height: "24px" }}>
        <IOSSpinner />
      </div>
    </div>
  );
};

export default PostSaveContainer;
